<template>
<v-dialog v-model="dialog" persistent max-width="960" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card tile flat>
        <v-card-title class="title primary white--text">
            <span>Article</span>
            <v-spacer></v-spacer>
            <v-icon color="white" @click="emitExit()">close</v-icon>
        </v-card-title>
        <v-card-text class="pt-2">
            <div style="position: relative; height: 3px">
                <v-progress-linear v-if="loading_data" indeterminate height="3" class="pa-0 ma-0" color="orange" style="position: absolute" />
            </div>
            <v-row wrap no-gutters>
                <v-col cols="12" md="4" class="px-1">
                    <v-card class="mb-3 elevation-1 pa-1">
                        <div class="detail font-weight-bold pa-0 ma-0">Place</div>
                        <im-place-search :place="item.place" class="im-select ma-0" solo placeholder="Any" @input="selectPlace($event)" hide-details />
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" class="px-1">
                    <v-card class="mb-3 elevation-1 pa-1">
                        <div class="detail font-weight-bold pa-0 ma-0">Section *</div>
                        <v-autocomplete class="im-select pa-0 ma-0" :items="sections" v-model="item.section_id" item-text="title.ro" item-value="id" flat solo clearable placeholder="Select section" />
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" class="px-1">
                    <v-card class="mb-3 elevation-1 pa-1">
                        <div class="detail font-weight-bold pa-0 ma-0">Language *</div>
                        <v-select class="im-select pa-0 ma-0" flat solo v-model="item.language" :items="language_items" item-value="value" item-text="text" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                            hide-details />
                    </v-card>
                </v-col>
            </v-row>

            <v-divider class="my-3" />

            <v-card flat>
                <v-text-field v-model="item.title" filled label="Title" />
            </v-card>

            <v-card flat>
                <tip-tap v-model="item.body"></tip-tap>
            </v-card>

            <v-divider class="my-3" />

            <v-row no-gutters>
                <v-col cols="12" md="6" class="px-1">
                    <v-card class="mb-3 elevation-1 pa-1">
                        <div class="detail font-weight-bold pa-0 ma-0">Order</div>
                        <v-text-field v-model="item.order" :rules="rules.order" class="im-select ma-0" solo flat clearable placeholder="Type here ..." />
                    </v-card>
                </v-col>
                <v-col cols="12" md="6" class="px-1">
                    <v-card class="mb-3 elevation-1 pa-1">
                        <div class="detail font-weight-bold pa-0 ma-0">Status *</div>
                        <v-select class="im-select pa-0 ma-0" flat solo v-model="item.status" :items="status_items" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" hide-details />
                    </v-card>
                </v-col>
                <v-col cols="12" class="px-1">
                    <v-card>
                        <div class="" style="position: relative; height: 3px">
                            <v-progress-linear v-if="loading_photos" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
                        </div>
                        <div class="text-center">
                            <input type="file" ref="fileInput" multiple accept="image/*" @change="onFileChanged" class="input-file">
                            Drag your file here to begin<br> or click to browse
                        </div>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-row no-gutters>
                        <v-col cols="6" md="3" v-for="(photo, index) in all_photos" :key="index" class="pa-2 text-xs-center">
                            <div style="position: relative">
                                <v-img :src="photo.url" height="200" cover />
                                <v-btn color="blue darken-2" @click="openDeletePhoto(photo, index)" small fab absolute right style="top: 7px">
                                    <v-icon medium color="red">delete_outline</v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="emitExit()">Cancel</v-btn>
            <v-btn color="primary" :loading="loading_save" @click="saveArticle()">Submit</v-btn>
        </v-card-actions>
        <!--delete dialog photo-->
        <v-dialog v-model="dialog_photo" max-width="320">
            <v-card>
                <v-card-text class="pt-2">
                    Are you sure you want to delete this photo?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="red" @click="destroyPhoto()">
                        Delete
                    </v-btn>
                    <v-btn color="primary" text @click="cancelDelete()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--./delete dialog photo-->
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from "vuex";
import defaults from "../utils/PropDefaults.js"
import TipTap from "../utils/TipTap2.vue";
import IMSectionSearch from '../utils/SectionSearch.vue';
import IMPlaceSearch from '../utils/IMPlaceSearch.vue';

export default {
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        id: {
            type: [Number, String],
            default: null
        }
    },

    components: {
        'im-place-search': IMPlaceSearch,
        'im-section-search': IMSectionSearch,
        'tip-tap': TipTap,
    },

    data() {
        return {
            old_status: "pending",
            item: this.$clone(defaults.article_item),
            dialog_photo: false,
            loading_data: false,
            loading_save: false,
            loading_delete: false,
            loading_photos: false,
            current_photo: null,
            new_photos: [],
            old_photos: [],
            all_photos: [],
            unique_ids: [],
            sections: [],
            status_items: [
                {
                    text: "Approved",
                    value: "approved"
                }, {
                    text: "Pending",
                    value: "pending"
                }, {
                    text: "Rejected",
                    value: "rejected"
                }
            ],
            language_items: [
                {
                    text: "English",
                    value: "en"
                }, {
                    text: "Romanian",
                    value: "ro"
                }
            ],
            rules: {
                order: [
                    v => !!v || "Order",
                    v => /^[1-9][0-9]?$|^100$/.test(v) || "Order must be between 1-100"
                ]
            },
        }
    },

    watch: {
        id: {
            handler() {
                if(!!this.id) {
                    this.getItem();
                    this.getPhotos(this.id);
                } else {
                    this.item = this.$clone(defaults.article_item);
                }
            }
        },
        dialog: {
            handler() {
                if(this.dialog == false) {
                    this.item = this.$clone(defaults.article_item);
                } else {
                    this.getSections();
                }
            }
        },
    },

    created() {
        if(!!this.id) {
            this.getItem();
            this.getPhotos(this.id);
        }
        this.getSections();
    },

    methods: {

        ...mapActions("alert", ["success", "error"]),

        emitClick() {
            this.$emit('click');
        },

        getSections() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/sections';

            // prepare params
            let options = {
                params: {
                    size: 100
                }
            };

            // make places search request
            this.$axios.get(endpoint, options)
                .then(response => {
                    this.sections = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        getItem() {
            this.loading_data = false;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/articles';

            this.$axios.get(endpoint + '/' + this.id) // eslint-disable-next-line
                .then(response => {
                    this.item = response.data;
                    this.old_status = response.data.status;
                })
                .catch(error => {
                    console.error(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading_data = false;
                });
        },

        saveArticle() {
            this.loading_save = true;

            this.new_photos.forEach(function (photo) {
                photo.place_id = this.item.place_id;
                photo.title = this.item.title;
                photo.status = this.item.status;
            }.bind(this));

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/articles';

            // call update or save endpoints
            if(this.item.id) {

                this.$axios.put(endpoint + '/' + this.item.id, this.item) // eslint-disable-next-line
                    .then(response => {
                        if(this.new_photos[0]) {
                            this.savePhoto(0, this.item.id);
                        }
                        if(this.old_status !== this.item.status) {
                            this.updatePhotos(0, this.item.status)
                        }
                        this.$emit('refresh');
                        this.success('Article updated.');
                        this.emitExit();
                    })
                    .catch(error => {
                        console.error(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });

            } else {

                this.$axios.post(endpoint, this.item) // eslint-disable-next-line
                    .then(response => {
                        if(this.new_photos[0]) {
                            this.savePhoto(0, response.data.id);
                        }
                        this.$emit('refresh');
                        this.success('Article created.');
                        this.emitExit();
                    })
                    .catch(error => {
                        console.log(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            }
        },

        clearPhotos() {
            this.all_photos = [];
            // this.new_photos = [];
        },

        getPhotos(article_id) {
            // this.loading = true;
            // prepare stamp & save current_stamp
            let stamp = Date.now();
            // setup query params
            let params = {
                params: {
                    article_ids: [article_id],
                    stamp: stamp
                }
            };

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/destinations/photos";

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.all_photos = response.data.data;
                    this.old_photos = response.data.data;

                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {
                    // this.loading = false;
                });
        },

        onFileChanged(event) {
            const files = event.target.files || event.dataTransfer.files;
            if(!files.length) {
                return;
            }

            Array.prototype.forEach.call(files, file => {
                this.createImage(file);
            });
        },

        generateUniqueId() {
            let nr_id = Math.floor((Math.random() * 10000) + 1);
            if(this.unique_ids.includes(nr_id)) {
                this.generateUniqueId();
            } else {
                this.unique_ids.push(nr_id)
                return nr_id
            }
        },

        createImage(file) {
            let id = this.generateUniqueId();
            const fileReader = new FileReader();
            fileReader.onload = event => {
                this.all_photos.push({
                    id: 'abc' + id,
                    url: event.target.result,
                });
                this.new_photos.push({
                    id: 'abc' + id,
                    place_id: null,
                    article_id: null,
                    photo: event.target.result,
                    description: this.item.title,
                    title: this.item.title,
                    status: this.item.status,
                    order: "50"
                });

            };
            fileReader.readAsDataURL(file);
        },

        destroyPhoto() {

            let value = this.current_photo.id.toString();
            if(value.includes("abc")) {
                // photo is a new one added
                let index = this.all_photos.findIndex(item => item.id === this.current_photo.id);
                this.all_photos.splice(index, 1);

                let new_index = this.new_photos.findIndex(item => item.id === this.current_photo.id);
                this.new_photos.splice(new_index, 1);

                this.current_photo = null;
                this.dialog_photo = false;
            } else {
                // photo is an old one and we need to call api
                let index = this.all_photos.findIndex(item => item.id === this.current_photo.id);
                // setup query endpoint
                let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
                let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/destinations/photos";

                // call delete endpoint

                this.$axios.delete(endpoint + "/" + this.current_photo.id) // eslint-disable-next-line
                    .then(response => {
                        this.all_photos.splice(index, 1);
                        this.success("Photo deleted!");
                        this.dialog_photo = false;
                        this.current_photo = null;
                    })
                    .catch(error => {
                        console.error(error);
                        this.error("Oops, something went wrong!");
                    })
                    .finally(() => {});
            }
        },

        openDeletePhoto(photo, index) {
            this.current_photo = photo;
            this.dialog_photo = true;
        },

        cancelDelete() {
            this.current_photo = null;
            this.dialog_photo = false;
        },

        savePhoto(index, article_id) {
            this.loading_save = true;
            this.new_photos[index].article_id = article_id;
            let photo = this.$clone(this.new_photos[index])
            delete photo.id;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/destinations/photos";

            setTimeout(() => {
                this.$axios.post(endpoint, photo)
                    .then(response => {
                        this.success("Photo added!");
                    })
                    .catch(error => {
                        console.log(error);
                        this.error("Oops, something went wrong!");
                    })
                    .finally(() => {
                        if(index < this.new_photos.length - 1) {
                            this.savePhoto(index + 1, article_id);
                        } else {
                            this.new_photos = [];
                            // this.upload_photos = false;
                        }
                        this.loading_save = false;
                    });
            }, 1000);
        },

        updatePhotos(index, status) {
            this.old_photos[index].status = status;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/photos';

            this.$axios.put(endpoint + '/' + this.old_photos[index].id, this.old_photos[index])
                .then(response => {
                    this.success('Photo updated!');
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    if(index < this.old_photos.length - 1) {
                        this.updatePhotos(index + 1, status);
                    } else {
                        this.old_photos = [];
                    }
                })
        },

        selectPlace(place) {
            if(place) {
                this.item.place_id = place.id;
            } else {
                this.item.place_id = null;
            }
        },

        selectSection(section) {
            if(section) {
                this.item.section_id = section.id;
            } else {
                this.item.section_id = null;
            }
        },

        emitExit() {
            this.all_photos = [];
            this.item = this.$clone(defaults.article_item);
            this.$emit('exit');
        }
    },

}
</script>
<style>
.articles-order-edit .im-select .v-input__control {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
}

.articles-order-edit .im-select .v-input__slot {
    max-height: 18px !important;
}

.articles-order-edit .im-select .v-text-field__details {
    margin-top: 8px;
}
</style>
